export interface DialogResult<T, U> {
  dismissed(callback: (reason?: U) => void): this
  submitted(callback: (result: T) => void): this
}

export class DialogResultImpl<T, U = any> implements DialogResult<T, U> {
  private dismissCallback?: (reason?: any) => void
  private submitCallback?: (result: T) => void

  constructor(executor: (submit: (value: T) => void, dismiss: (reason?: U) => void) => void) {
    executor(
      (result: T) => {
        if (this.submitCallback !== undefined) {
          this.submitCallback(result)
        }
      },
      reason => {
        if (this.dismissCallback !== undefined) {
          this.dismissCallback(reason)
        }
      }
    )
  }

  public dismissed(callback: (reason?: U) => void): this {
    this.dismissCallback = callback

    return this
  }

  public submitted(callback: (result: T) => void): this {
    this.submitCallback = callback

    return this
  }
}
